import React, { useState, useEffect } from "react";
import "./Payment.css";
import ConfirmationPage from "../ConfirmationPage";
import { BASE_URL } from "../../helpers/api"; // make sure you have this
import { useNavigate } from "react-router-dom";


export default function PaymentForm() {
  const [confirmed, setConfirmed] = useState(false);
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();


  const amount = 900;

  useEffect(() => {
    const fetchAppointment = async () => {
      const appointmentId = localStorage.getItem("appointment_id"); // saved after booking
      if (!appointmentId) {
        setLoading(false);
        return;
      }
      try {
        const res = await fetch(`${BASE_URL}/appointments/${appointmentId}`);
        const data = await res.json();
        console.log("Fetched appointment:", data);
        setAppointment(data);
      } catch (err) {
        console.error("Error fetching appointment:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointment();
  }, []);

  if (loading) {
    return <p>Loading appointment...</p>;
  }

  if (!appointment) {
    return <p>No appointment found.</p>;
  }

  if (confirmed) {
    return (
      <ConfirmationPage
        doctorDetails={{
          doctorName: appointment?.doctor?.name || "N/A",
          qualification: appointment?.doctor?.degree?.replace(/<[^>]+>/g, "") || "N/A",
          experience: "12 Years Of Experience", // TODO: add to user table
          specialization: appointment?.doctor?.specialty || "N/A",
          location: appointment?.location?.name || "N/A",
        }}
        patientDetails={{
          name: appointment?.patient?.name || "N/A",
          age: "N/A", // TODO: calculate from patient DOB
          date: appointment?.date || "N/A",
          slotTime: appointment?.time_slot || "N/A",
          type: "NEW", // TODO: detect from appointment history
          email: appointment?.patient?.email || "N/A",
        }}
        amount={amount}
      />
    );
  }

  return (
    <div className="payment-container">
      <h2 className="page-title">Appointment Summary</h2>

      {/* Doctor Details */}
      <div className="summary-card">
        <h3>Doctor Details</h3>
        <p>
          <strong>Name:</strong> {appointment?.doctor?.name || "N/A"}
        </p>
        <p>
          <strong>Degree:</strong> {appointment?.doctor?.degree?.replace(/<[^>]+>/g, "") || "N/A"}
        </p>
        <p>
          <strong>Specialty:</strong> {appointment?.doctor?.specialty || "N/A"}
        </p>
      </div>

      {/* Patient Details */}
  <div className="summary-card">
  <h3>Patient Details</h3>
  <p><strong>Name:</strong> {appointment?.patient?.name || "N/A"}</p>
  <p><strong>Email:</strong> {appointment?.patient?.email || "N/A"}</p>
  <p><strong>Phone:</strong> {appointment?.patient?.phone || "N/A"}</p>
  <p><strong>Date:</strong> {appointment?.date || "N/A"}</p>
  <p><strong>Time:</strong> {appointment?.time_slot || "N/A"}</p>
  <p><strong>Location:</strong> {appointment?.location?.name || "N/A"}</p>
  <p><strong>Reason:</strong> {appointment?.problem || "N/A"}</p>
</div>

      {/* Fee Details */}
      <div className="summary-card">
        <h3>Fee Details</h3>
        <p>
          <strong>Consultation Fee:</strong> ₹{amount}
        </p>
        <p>
          <strong>Total Payable:</strong> ₹{amount}
        </p>

        <div className="fee-actions">
       <button className="btn-back" onClick={() => navigate(-1)}>
        BACK
      </button>
          <button className="btn-confirm" onClick={() => setConfirmed(true)}>
            CONFIRM
          </button>
        </div>
      </div>
    </div>
  );
}
